import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/blocks/AdvertisementBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/blocks/SidebarNewsGridBlock/SidebarNewsGridCarousal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/cards/HorizontalArticleCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/cards/TextOverArticleCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/cards/VerticalArticleCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LexicalRichText"] */ "/app/src/components/LexicalRichText/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shared/CustomImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shared/SocialShare.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/interviews/LikeBookmarkSection.tsx");
